import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { forwardRef } from 'react';
import { TabsDisplayType } from '../types/display-type';
const b = bemClassBuilder('v-tab');
const TabBase = (props, ref) => {
    const { tab, onClick, selected, displayType } = props;
    const isSecondaryDisplayType = displayType === TabsDisplayType.Secondary;
    const showIndicator = selected && !isSecondaryDisplayType;
    return (_jsxs("li", Object.assign({ className: b.block({ selected: selected, type: displayType }), role: "presentation", ref: ref }, { children: [_jsx("button", Object.assign({ className: b.element('button'), role: "tab", "aria-selected": selected, onClick: () => onClick(tab) }, { children: _jsx("span", { children: tab.label }) })), showIndicator && (_jsx(motion.div, { className: b.element('indicator'), layoutId: "indicator", transition: { type: 'spring', damping: 17 } }))] })));
};
export const Tab = observer(forwardRef(TabBase));
Tab.displayName = 'Tab';
